module.exports = __webpack_public_path__ + "img/pocket_en.a6763cf.jpg";